export function getHexColorByHue(hue) {
    switch (hue) {
        case androidHues.HUE_AZURE:
            return "#03A9F4"
        case androidHues.HUE_BLUE:
            return "#1565C0"
        case androidHues.HUE_CYAN:
            return "#00838F"
        case androidHues.HUE_GREEN:
            return "#2E7D32"
        case androidHues.HUE_MAGENTA:
            return "#9C27B0"
        case androidHues.HUE_ORANGE:
            return "#EF6C00"
        case androidHues.HUE_RED:
            return "#c62828"
        case androidHues.HUE_ROSE:
            return "#E91E63"
        case androidHues.HUE_VIOLET:
            return "#673AB7"
        case androidHues.HUE_YELLOW:
            return "#FDD835"
        default:
            // Return "black" indicating unmapped status.
            return "#212121"
    }
}

/**
 * An enum of hue values assignable from Android.
 * See: https://developers.google.com/android/reference/com/google/android/gms/maps/model/BitmapDescriptorFactory.html#HUE_AZURE
 */
export const androidHues = {
    HUE_AZURE: 210,
    HUE_BLUE: 240,
    HUE_CYAN: 180,
    HUE_GREEN: 120,
    HUE_MAGENTA: 300,
    HUE_ORANGE: 30,
    HUE_RED: 0,
    HUE_ROSE: 330,
    HUE_VIOLET: 270,
    HUE_YELLOW: 60
}
